import { useRef } from 'react';
import { MarkdownRenderer } from '~/components/markdown-renderer';
import { useMermaidBlocks, usePaintedDark } from './mermaid-blocks';

/**
 * FRONT-2669 — the Canvas document Preview's Markdown: the shared renderer plus
 * drawn diagrams. Only this surface draws mermaid fences; chat bubbles and every
 * other MarkdownRenderer caller keep showing them as code.
 */
export function CanvasMarkdown({ content }: { content: string }) {
  const ref = useRef<HTMLDivElement>(null);
  useMermaidBlocks(ref, content, usePaintedDark());
  return (
    <div ref={ref}>
      <MarkdownRenderer content={content} />
    </div>
  );
}
